{
    "21MMvI7yiQk-eWt-XzCCh": {
        "position": {
            "x": 14,
            "y": 19,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "21MMvI7yiQk-eWt-XzCCh"
    },
    "c0Rfv2wmNvW_qWPvYHcqI": {
        "position": {
            "x": 13,
            "y": 19,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "c0Rfv2wmNvW_qWPvYHcqI"
    },
    "iUuOP6vdeJOppow6IsEME": {
        "position": {
            "x": 16,
            "y": 19,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "iUuOP6vdeJOppow6IsEME"
    },
    "RfFs6gcj04zVU_27wlvxW": {
        "position": {
            "x": 15,
            "y": 19,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "RfFs6gcj04zVU_27wlvxW"
    },
    "d2hEYy9MbtXn5r4BA6B0a": {
        "position": {
            "x": 14,
            "y": 11,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "d2hEYy9MbtXn5r4BA6B0a"
    },
    "EUShZBk5p_14xdrmargAk": {
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "EUShZBk5p_14xdrmargAk"
    },
    "xKUdK5vCDli4gw_XJtpC7": {
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "xKUdK5vCDli4gw_XJtpC7"
    },
    "5Q7eKwCEZwtY_AzbA7ixb": {
        "position": {
            "x": 15,
            "y": 11,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "5Q7eKwCEZwtY_AzbA7ixb"
    },
    "kNUsjg4rysOoFQEF5VM5i": {
        "position": {
            "x": 13,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/priest",
        "jobKey": "priest",
        "affiliation": "bad",
        "ai": {
            "behaviors": [
                "avoiding",
                "healing first"
            ]
        },
        "key": "kNUsjg4rysOoFQEF5VM5i"
    },
    "prbAYoC5mdwfnRFJ9Wz7a": {
        "position": {
            "x": 14,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/priest",
        "jobKey": "priest",
        "affiliation": "bad",
        "ai": {
            "behaviors": [
                "avoiding",
                "healing first"
            ]
        },
        "key": "prbAYoC5mdwfnRFJ9Wz7a"
    },
    "3iRYHXjDq5T-DnFF1lNAO": {
        "position": {
            "x": 16,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/priest",
        "jobKey": "priest",
        "affiliation": "bad",
        "ai": {
            "behaviors": [
                "avoiding",
                "healing first"
            ]
        },
        "key": "3iRYHXjDq5T-DnFF1lNAO"
    },
    "aHih-_Mjgu_cMNrqoSlA3": {
        "position": {
            "x": 18,
            "y": 11,
            "z": 1
        },
        "templateKey": "jobs/hammercavalier",
        "jobKey": "hammercavalier",
        "affiliation": "bad",
        "key": "aHih-_Mjgu_cMNrqoSlA3"
    },
    "h3LX1u-b3ZGsoYX_WXS6O": {
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "bad",
        "key": "h3LX1u-b3ZGsoYX_WXS6O"
    },
    "DU-OyrTGw0oaAKI5zYm5b": {
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "bad",
        "key": "DU-OyrTGw0oaAKI5zYm5b"
    },
    "0EmUwvVUjkRsjlY7i4-Oo": {
        "position": {
            "x": 13,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/hammerknight",
        "jobKey": "hammerknight",
        "affiliation": "bad",
        "key": "0EmUwvVUjkRsjlY7i4-Oo"
    },
    "dlK_Y1-QXv07nDCMYL6x3": {
        "position": {
            "x": 16,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/swordknight",
        "jobKey": "swordknight",
        "affiliation": "bad",
        "key": "dlK_Y1-QXv07nDCMYL6x3"
    },
    "Je2JifFeBxz1pX-TOFjKo": {
        "position": {
            "x": 11,
            "y": 11,
            "z": 1
        },
        "templateKey": "jobs/swordcavalier",
        "jobKey": "swordcavalier",
        "affiliation": "bad",
        "key": "Je2JifFeBxz1pX-TOFjKo"
    },
    "warlord": {
        "position": {
            "x": 15,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/swordknight",
        "jobKey": "swordknight",
        "affiliation": "bad",
        "key": "warlord",
        "maxhealth": 70,
        "name": "Warlord",
        "properties": ["boss"],
        "defense": 5,
        "resistance": 2
    }
}
